import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Gallery = () => {
  const images = [
    { thumb: 'images/babbb.png', title: 'Dubová socha patrona' },
    { thumb: 'images/baba.png', title: 'Reliéf – lesní motiv' },
    { thumb: 'images/babb.png', title: 'Plastika z tisu' },
    { thumb: 'images/babbb.png', title: 'Detail řezby' },
  ];

  const infiniteImages = [...images, ...images];

  return (
    <section style={{ backgroundColor: '#fef3dc', padding: '80px 0', overflow: 'hidden' }}>
      
      {/* ANIMOVANÝ CITÁT A NADPIS */}
      <motion.div 
        style={{ maxWidth: '900px', margin: '0 auto 40px auto', textAlign: 'center', padding: '0 20px' }}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <motion.img 
          src="images/dlato.png" 
          alt="Dláto" 
          style={{ width: '150px', marginBottom: '16px', opacity: 0.7 }}
          initial={{ rotate: -10 }}
          whileInView={{ rotate: 0 }}
          transition={{ duration: 1, type: "spring" }}
        />
        <p style={{ fontSize: '1.1rem', fontStyle: 'italic', color: '#5a4935', marginBottom: '10px' }}>
          Každý detail začíná s dřevem a končí s duší
        </p>
        <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#2b1f18' }}>
          Ukázka děl z mé dílny
        </h2>
      </motion.div>

      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .slider-track {
            display: flex;
            width: fit-content;
            animation: scroll 25s linear infinite;
          }
          .slider-track:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      {/* Nekonečný slider s Framer Motion hover efektem na karty */}
      <div className="slider-track" style={{ gap: '20px', padding: '0 10px' }}>
        {infiniteImages.map((img, index) => (
          <motion.div 
            key={index} 
            whileHover={{ scale: 0.98 }} // Jemné zmenšení při hoveru pro efekt hloubky
            style={{ 
              minWidth: '350px', 
              height: '400px', 
              position: 'relative', 
              borderRadius: '15px', 
              overflow: 'hidden',
              flexShrink: 0,
              cursor: 'pointer'
            }}
          >
            <img 
              src={img.thumb} 
              alt={img.title} 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
            />
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, 
              background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
              padding: '20px', color: '#fff',
              fontSize: '1.1rem',
              fontWeight: '600'
            }}>
              {img.title}
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div 
        style={{ textAlign: 'center', marginTop: '50px' }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          style={{ display: 'inline-block' }}
        >
          <Link to="/galerie" className="btn-dubai">Vstoupit do celé galerie</Link>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Gallery;